//import { StatusBar } from 'expo-status-bar';
import React, { useEffect, useState, useRef, Fragment } from "react";
import { StyleSheet, Text, View, FlatList, ActivityIndicator, ScrollView, TouchableOpacity, TouchableHighlight } from 'react-native';

import Button from 'react-native';
//import Button from 'apsl-react-native-button';

import FlatListSeanceItem from './FlatListSeanceItem';
// paper
import { FAB, TextInput } from 'react-native-paper';
// g-sheet
import Papa from "papaparse";
// storage
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useAsyncStorage } from '@react-native-async-storage/async-storage';
// REDUX
import { useSelector, useDispatch } from 'react-redux'
import { saveprofildata } from '../Store/dataStore'
import { savedata } from '../Store/dataStore'
import { savecode } from '../Store/dataStore'



const clearAppData = async function() {
    try {
        const keys = await AsyncStorage.getAllKeys();
console.log('keys:'+keys);
        if ((keys != '') && (keys != null))
        {
          await AsyncStorage.multiRemove(keys);
          console.log("CLEAR ASYNC STORAGE OK.");
        }
    } catch (error) {
        console.error('Error clearing ASYNC data.'+error);
    }
}




function ProfilEtProgrammes ({navigation}) {

// text input ref
const inputRef = useRef();

// ASYNC Storage
const writeCodeToAsyncStorage = async code => {
console.log("ProfilEtProgrammes writeCodeToAsyncStorage...:"+code);
  try {
      await AsyncStorage.setItem('@storage_key_CODE', code)
  } catch (e) {
    console.log("erreur ProfilEtProgrammes writeCodeToAsyncStorage:"+e);
  }
};


const writeProfilDataToAyncStorage = async newValue => {
console.log("ProfilEtProgrammes writeProfilDataToAyncStorage...");
    try {
      const jsonValue = JSON.stringify(newValue)
      await AsyncStorage.setItem('@storage_key_PROFILDATA', jsonValue);
console.log("ProfilEtProgrammes writeProfilDataToAyncStorage OK.");//+jsonValue);
    } catch(e) {
      console.log("erreur ProfilEtProgrammes writeProfilDataToAyncStorage:"+e);
    }
  };

const writeDataToAsyncStorage = async newValue => {
console.log("ProfilEtProgrammes writeDataToAsyncStorage...");
  try {
    const jsonValue = JSON.stringify(newValue)
    await AsyncStorage.setItem('@storage_key_DATA', jsonValue);
console.log("ProfilEtProgrammes writeDataToAsyncStorage OK");
  } catch(e) {
    console.log("ERREUR ProfilEtProgrammes writeDataToAsyncStorage:"+e);
  }
};

const writeDataProgrammeToAsyncStorage = async (newValue, gid) => {
console.log("ProfilEtProgrammes writeDataProgrammeToAsyncStorage...");
  try {
    const jsonValue = JSON.stringify(newValue)
    await AsyncStorage.setItem('@storage_key_DATA_'+gid, jsonValue);
console.log("ProfilEtProgrammes writeDataProgrammeToAsyncStorage OK");
  } catch(e) {
    console.log("erreur ProfilEtProgrammes writeDataProgrammeToAsyncStorage:"+e);
  }
};


const clearDataFromAsyncSaufCode = async function() {
console.log('clearDataFromAsyncSaufCode...');
    try {
        const keys = await AsyncStorage.getAllKeys();
console.log('keys:'+keys);
console.log('delete keys');
        if ((keys != '') && (keys != null))
        {
          await AsyncStorage.multiRemove(keys);
console.log("CLEAR ASYNC STORAGE OK.");
        }
console.log('save code to async:'+code);
        await AsyncStorage.setItem('@storage_key_CODE', code);
        //setEnterNewCode(false);
        loadProfilDataFromGSheet(code);
    } catch (error) {
        console.error('Error clearing ASYNC data.'+error);
    }
}


// REDUX data
const dataRedux = useSelector((state) => state.data)
const profilDataRedux = useSelector((state) => state.profilData)
const dispatch = useDispatch()

const saveProfilDataToRedux = profildata =>
{
console.log("ProfilEtProgrammes: saveProfilDataToRedux...");
  dispatch(saveprofildata(profildata))
//console.log(profilDataRedux);
}

const saveDataToRedux = data =>
{
console.log("ProfilEtProgrammes: saveDataToRedux...");
  dispatch(savedata(data))
//console.log(dataRedux);
}


// HOOKS
  // profil
  const [profilDataLocal, setProfilDataLocal] = useState("");
  // code
  const [code, setCode] = useState('');
  const [codeOK, setCodeOK] = useState(false);
  const [codeLocal, setCodeLocal] = useState("");
  const [erreurCode, setErreurCode] = useState(false);
  const [erreurProgrammeGid, setErreurProgrammeGid] = useState(false);
  const [enterNewCode, setEnterNewCode] = useState(false);
  // interface
  const [isLoading, setIsLoading] = useState(false);
  const [majProfilOK, setMajProfilOK] = useState(false);

// FONCTIONS
const toggleEnterNewCode = (newValue) => {
  setEnterNewCode(!enterNewCode);
  if (newValue)
  {
    inputRef.current.focus();
  }
  else {
    inputRef.current.blur();
  }
}

  // Load Profil
  const loadProfilDataFromGSheet = (codeValue) => {
//console.log("route: "+route);
//console.log("loaddata: route params displaySetNewCode = "+route.params.displaySetNewCode);
console.log("ProfilEtProgrammes loadProfilDataFromGSheet...");

      setCodeOK(false);
      setMajProfilOK(false);
      setIsLoading(true);

      // enleve les espaces (regex '/X/gi' remplace TOUTES les occurences de X)
      var codeValue = codeValue.replace(/ /gi,"");

      // Load PROFIL GSheet (gid 0)
      var publicSpreadsheetUrl = 'https://docs.google.com/spreadsheets/d/e/'+codeValue+'/pub?gid=0&single=true&output=csv';

        Papa.parse(publicSpreadsheetUrl, {
        download: true,
        header: true,
        error: function(err, file, inputElem, reason)
        {
console.log("ProfilEtProgrammes loadProfilDataFromGSheet: ERROR PAPA");
        		// executed if an error occurs while loading the file,
        		// or if before callback aborted for some reason
            console.warn(err);
            setIsLoading(false);
            setMajProfilOK(false);
            setCodeOK(false);
            setErreurCode(true);
        },
        complete: function(results)
        {
console.log("ProfilEtProgrammes loadProfilDataFromGSheet OK");
          //console.log(results)
          var dataFromGSheet = results.data

          // Save PROFIL data
          writeProfilDataToAyncStorage(dataFromGSheet);
          saveProfilDataToRedux(dataFromGSheet);
          setProfilDataLocal(dataFromGSheet);

          // OK: affichage
          setIsLoading(false);
          setMajProfilOK(true);
          setCodeOK(true);
          setErreurCode(false);
          //setCodeLocal(codeValue);

          // Save CODE
          writeCodeToAsyncStorage(codeValue);
          //saveCodeToRedux(codeValue);
          setCode(codeValue);
          // reinit textinput
          setCodeLocal("");
          setEnterNewCode(false);
          console.log("ProfilEtProgrammes loadProfilDataFromGSheet, writeCodeToAsyncStorage DONE.");
        }
      });
  };


  useEffect( () => {
// Clear DATA pour DEBUG
//console.log("CLEAR ASYNC STORAGE (pour DEBUG)...!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");
clearAppData();

    const readCodeFromAsyncStorage = async () => {
console.log("ProfilEtProgrammes useFx: readCodeFromAsyncStorage... ");
      try {
        const codeValue = await AsyncStorage.getItem('@storage_key_CODE')
        //setCodeLocal(codeValue);
        if (codeValue !== null) {
          //saveCodeToRedux(codeValue);
          setCode(codeValue);
          setCodeOK(true);
        }
        else {
          setCodeOK(false);
        }
      } catch(e) {
console.log("ProfilEtProgrammes useFx: readCodeFromAsyncStorage ERREUR: "+e);
        setCodeOK(false);
      }
    }

    const readProfilDataFromAsyncStorage = async () => {
      try {
        const jsonValue = await AsyncStorage.getItem('@storage_key_PROFILDATA')
        const parsedData = jsonValue != null ? JSON.parse(jsonValue) : null;
        if (parsedData !== null) {
          saveProfilDataToRedux(parsedData);
          setProfilDataLocal(parsedData);
          setMajProfilOK(true);
console.log("ProfilEtProgrammes useFX: readProfilDataFromAsyncStorage OK."); //++profilData);
        }
        else {
          setMajProfilOK(false);
console.log("ProfilEtProgrammes useFX: readProfilDataFromAsyncStorage NO DATA (ok)"); //++profilData);
        }
      } catch(e) {
        setMajProfilOK(false);
        console.log("ProfilEtProgrammes useFX: readProfilDataFromAsyncStorage ERREUR: "+e);
      }
    }

console.log("ProfilEtProgrammes useFX: readProfilDataFromAsyncStorage ONCE au lancement...");
    readCodeFromAsyncStorage();
    readProfilDataFromAsyncStorage();
//  }, []); // FIRST rendering ONLY
}, [navigation]); // FIRST rendering + si navigation change
//}); // EVERY rendering



  return (

  <View style={{flex: 1, backgroundColor: 'lightyellow',}}>

    { (erreurCode && !isLoading) && (
        <View style={styles.maj}>
          <Text style={styles.maj}>{"Code invalide :("}</Text>
        </View>
    )}

    { (erreurProgrammeGid && !isLoading) && (
        <View style={styles.maj}>
          <Text style={styles.maj}>{"Programme non-accessible :("}</Text>
        </View>
    )}


  { ((!majProfilOK && !isLoading) || enterNewCode) ?
      <View style={{margin: 10}}>
      <Text style={{fontSize:5}}>{"\n"}</Text>
      <TextInput
        ref={inputRef}
        label="Entre ton code Z'Run ici !"
        value={codeLocal}
        mode='outlined'
        onChangeText={setCodeLocal}
        style={styles.code}
      />
      <Text style={{fontSize:5}}>{"\n"}</Text>
      <View style={{flexDirection: 'row', justifyContent:'space-between'}}>
        <FAB
          style={{backgroundColor: 'lightyellow',}}
          small
          label="Annuler"
          icon='cancel'
          //disabled={codeLocal == '' ? true : false}
          onPress={() => setEnterNewCode(false)}
        />
        <FAB
          small
          label="Valider"
          icon='check'
          disabled={codeLocal == '' ? true : false}
          onPress={() => loadProfilDataFromGSheet(codeLocal)}
        />
      </View>
    </View>
    : null
  }

  { (isLoading) ?
    <View style={{flex: 1}}>
      <ActivityIndicator size="large" color="#0000ff" />
    </View>
    : null
  }

    { (isLoading || !majProfilOK || enterNewCode) ?
    null :
    <View style={{flex: 1}}>
      <View
          style={{flex: 1, margin: 20, borderWidth:1, backgroundColor: '#DDFDDF',}}>
        <FlatList
          data={profilDataLocal}
          keyExtractor={(item) => item.id} //.toString()
          //renderItem={({item}) =>
          //<FlatListSeanceItem seance={item} />
          //}
          renderItem={ ({item}) =>
            <View style={{margin: 10, backgroundColor: '#DDFDDF',}}>
              { (item.programme == "PROFIL") ?
                <View>
                  <Text style={{fontSize: 20}}>{item.nom}</Text>
                  { (item.date != "") ?
                    <Text>Abonnement jusqu'au {item.date}</Text>
                    : null
                  }
                </View>
                  : null
              }
            </View>
          }
        />
      </View>

      <View style={{flex: 4}}>
        <FlatList
          data={profilDataLocal}
          keyExtractor={(item) => item.id} //.toString()
          //renderItem={({item}) =>
          //<FlatListSeanceItem seance={item} />
          //}
          renderItem={ ({item}) =>
            <View style={{flex: 1, backgroundColor: 'lightyellow',}}>
              { ((item.actif != "") && (item.gid != "0")) ?
                <View style={{justifyContent:'center', flexDirection:'row', backgroundColor: 'lightyellow'}} >
                  <FAB
                  onPress={() => navigation.navigate("ProgrammeGid", { gid: item.gid, code:code, couleur:item.couleur })}
                  style={{
                    //backgroundColor: "#AAFBBF",
                    backgroundColor: (item.couleur != "") ? item.couleur : "#DDDDDD",
                    borderColor: "transparent",
                    borderRadius: 20,
                    width: 250,
                    margin: 10
                  }}
                  textStyle={{
                    color: "#000000",
                    fontSize: 20
                  }}
                  //>
                  label={item.programme}
                  />
                </View>
                  : null
              }
            </View>
          }
        />
      </View>

      <View style={{flex: 1, justifyContent:'center',}}>
        <View style={{alignItems:'center', flexDirection: 'row', justifyContent: 'space-between'}}>
          <TouchableHighlight
                      style={{flex: 1}}
                      onLongPress={() => toggleEnterNewCode(!enterNewCode)}
                      underlayColor='lightyellow'
                      delayLongPress={4000} >
            <Text style={styles.nouveau_code}></Text>
          </TouchableHighlight>
          <FAB
            small
            //style={{backgroundColor:'orange'}}
            style={{backgroundColor:'lightyellow'}}
            label="Mise à jour"
            icon='update'
            color="#000000"
            onPress={() => clearDataFromAsyncSaufCode()}
          />
          <TouchableHighlight
                      style={{flex: 1}}
                      onLongPress={() => toggleEnterNewCode(!enterNewCode)}
                      underlayColor='lightyellow'
                      delayLongPress={4000} >
            <Text style={styles.nouveau_code}></Text>
          </TouchableHighlight>
        </View>
      </View>


      </View>



    }

    </View>
  );

};


const styles = StyleSheet.create({
  container: {
    marginTop: 30,
    flex: 1,
    backgroundColor: 'lightyellow',
    alignItems: 'center',
    justifyContent: 'center',
  },
  nouveau_code: {
    fontSize: 20,
    margin: 10,
    //flex: 1,
    justifyContent:'center',
    flexDirection:'row',
  },
  maj: {
    fontSize: 30,
    //marginBottom: 20,
    alignItems: 'center',
    textAlign: 'center',
    //top: 20,
    //bottom: 20,
    backgroundColor: '#DDFDDF', // vert clair
    //flex: 1,
  },
});



export default ProfilEtProgrammes
